import React from "react";
import { Grid, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format } from 'date-fns';
import FeatherIcon from "feather-icons-react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../components/auth/AuthContext.js";
import TableComponent from "../../components/table/list.jsx";
import { DATE_FORMAT, LIST_NULL_OPTION_VALUE } from "../../helpers/constant.js";
import Utils from "../../utils";
import CreateCampaignStepTwo from "./create-campaign-step-two.jsx";
import CreateCampaign from "./create-campaign.jsx";
import EditCampaignComponent from "./edit-campaign.jsx";
import PinUnpinConfirmButton from "./pin-unpin-confirm.jsx";
import { AppDataContext } from "../../components/context/app-data-context.jsx";
import { CustomTooltip, LinearProgressWithLabel } from "../../consts.js";
import { getComparatorSort, roundNumberHelper } from "../../helpers/index.js";

function Campaigns() {
    let navigate = useNavigate();
    const [value, setValue] = React.useState(null);
    const [newCampDiag, setNewCampDiag] = React.useState(false);
    const [editCampaignDialog, setEditCampaignDialog] = React.useState(false);
    const [editCampaignData, setEditCampaignData] = React.useState({});
    const [spinner, setSpinner] = React.useState(false);
    const [newCampDiag2, setNewCampDiag2] = React.useState(false);
    const [diag2input, setDiag2input] = React.useState(null);
    const [age] = React.useState("");
    const [trackers, setTrackers] = React.useState([]);
    const [companyData, setCompanyData] = React.useState({});
    const [allCampaigns, setAllCampaigns] = React.useState([]);
    const [dataLoaded, setDataLoaded] = React.useState(false);

    const { currentNonAdminGroup } = React.useContext(AuthContext);
    const AppDataContextDTO = React.useContext(AppDataContext);

    async function getCompanyName(noSpinner) {
        Utils.sendProgressBar(true);
        if (!noSpinner) setSpinner(true);
        let userData = await Utils.getUserGroupFromCognito();
        let user = userData?.filter((z) => z !== "admin");

        let company = await Utils.genericList("listCompanies", {
            filter: { internalname: { eq: user[0] } },
        });
        company = company.data.listCompanies.items[0].id;
        company = await Utils.genericGet("getCompany", company);
        company = company.data.getCompany;
        setCompanyData(company);
        company.trackers = JSON.parse(company.trackers);
        const newTrackers = company.trackers.filter((l) => l.phrases.length > 0);
        setTrackers(newTrackers);

        const campaigns = await Utils.genericList("listCampaigns");
        const listCampaigns = campaigns.data.listCampaigns.items;
        for (const campaign of listCampaigns) {
            campaign.vocalysdScore = campaign.VShits ? roundNumberHelper(JSON.parse(campaign.VShits).VS / JSON.parse(campaign.VShits).n) : 0;
        }
        const sortedRows = [...listCampaigns].sort(getComparatorSort("desc", "createdAt"));
        setAllCampaigns(sortedRows);
        setSpinner(false);

    }

    React.useEffect(() => {
        try {
            AppDataContextDTO.clearAppData();
        } catch (error) {

        }
    }, [])

    React.useEffect(() => {
        if (!dataLoaded) {
            const fetchData = async () => {
                await getCompanyName(); // Your async data fetching function
                setDataLoaded(true); // Mark data as loaded
            };
            fetchData();
        }

        window.scrollTo(0, 0); // Scroll to top when component mounts

    }, [dataLoaded]);

    const columns = [
        {
            label: "Campaign/Entity",
            key: "name",
            sortable: true,
            renderItem: (row) => (<>
                <div
                    style={{
                        fontWeight: 500,
                    }}
                >
                    {row.name || "-"}
                </div>
                <div>
                    {row.company?.name}
                </div>
            </>)
        },
        {
            label: "Pin",
            key: "pinned",
            sortable: true,
            renderItem: (row) => (<PinUnpinConfirmButton
                data={row}
                onSuccess={(state) => {
                    const _data = [...allCampaigns];
                    for (const campaign of _data) {
                        if (campaign.id === row.id) {
                            campaign.pinned = state;
                            break;
                        }
                    }
                    setAllCampaigns(_data);
                    getCompanyName(true);
                }} />)
        },
        {
            label: "Type",
            key: "type",
            sortable: true,
            renderItem: (row) => row.type || "-",
        },
        {
            label: "Direction",
            key: "direction",
            sortable: true,
            renderItem: (row) => row.direction || "-",
        },
        {
            label: "Status",
            key: "active",
            sortable: true,
            renderItem: (row) => (<Chip
                label={row.active ? "Active" : "Inactive"}
                color={row.active ? "success" : "info"}
            />)
        },
        {
            label: "Avg. Vocalysd Score",
            key: "vocalysdScore",
            sortable: true,
            renderItem: (row) => <LinearProgressWithLabel variant="determinate" value={row.vocalysdScore || 0} />,
        },
        {
            label: "Date Created",
            key: "startdate",
            sortable: true,
            renderItem: (row) => (<>
                {format(new Date(row.startdate), DATE_FORMAT) || "-"}
            </>)
        },
        {
            label: "Edit",
            key: "edit",
            sortable: false,
            renderItem: (row) => (<CustomTooltip title={"Edit"}>
                <IconButton aria-label="Edit" size="small" color="inherit" onClick={async (e) => {
                    e.stopPropagation();
                    setEditCampaignData(row);
                    setEditCampaignDialog(true);
                }}>
                    <FeatherIcon icon="edit-2" size={20} />
                </IconButton>
            </CustomTooltip>)
        },
    ]

    const headerActionButtons = () => {
        return (
            <Button
                variant="contained"
                onClick={() => setNewCampDiag(true)}
                startIcon={<FeatherIcon icon="folder-plus" size={20} />}
            >
                New Campaign
            </Button>
        )
    }
    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            <Grid
                className="vocalysed-home-upadted campaigns"
                container
                spacing={0}
                direction="column"
                flexWrap="nowrap"
                flexGrow={1}
                paddingTop={2}
                paddingX={3}
                paddingBottom={3}
                overflow="auto"
            >
                <TableComponent
                    headerActionButtons={headerActionButtons}
                    spinner={spinner}
                    data={allCampaigns}
                    columns={columns}
                    pagination={true}
                    searchKeys={["name", "type", "company.name"]}
                    filterTypes={{ campaignType: "type", callDirection: "direction" }}
                    defaultFilterValues={{ campaignType: LIST_NULL_OPTION_VALUE, callDirection: LIST_NULL_OPTION_VALUE }}
                    noDataMessage={"No campaigns found."}
                    defaultOptions={{ sortKey: 'pinned', sortOrder: 'asc' }}
                    rowClick={(item) => navigate("/campaign?id=" + item.id)}
                />

                {true ? null : (
                    <div style={{ width: "20%", background: "#fff", marginLeft: 10 }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "row",
                            }}
                        >
                            <div>Filters</div>
                            <Button variant="text">Reset All</Button>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "column",
                            }}
                        >
                            <div>Date Range</div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    label="From"
                                    value={value}
                                    onChange={(newValue) => {
                                        setValue(newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                                <DatePicker
                                    label="To"
                                    value={value}
                                    onChange={(newValue) => {
                                        setValue(newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                            <div>Limit To</div>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Age</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={age}
                                    label="Entity"
                                >
                                    <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Age</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={age}
                                    label="Campaigns"
                                >
                                    <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Age</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={age}
                                    label="Agents"
                                >
                                    <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem>
                                </Select>
                            </FormControl>
                            <Button variant="outlined">
                                Apply
                            </Button>
                        </div>
                    </div>
                )}
            </Grid>

            {/* Modals */}
            <CreateCampaign
                open={newCampDiag}
                companyData={companyData}
                onClose={(data) => {
                    if (data === null) {
                        setNewCampDiag(false);
                        setDiag2input(data);
                    } else {
                        data.trackers = trackers;
                        setDiag2input(data);
                        setNewCampDiag(false);
                        if (data !== null) setNewCampDiag2(true);
                    }
                }}
                allCampaigns={allCampaigns}
            />
            <CreateCampaignStepTwo
                currentNonAdminGroup={currentNonAdminGroup}
                open={newCampDiag2}
                data={diag2input}
                onClose={async (dataResponse) => {
                    if (dataResponse === null) {
                        setNewCampDiag2(false);
                    } else {
                        setDiag2input(null);
                        setNewCampDiag2(false);
                        navigate("/campaign?id=" + dataResponse.data.createCampaign.id);
                    }
                }}
                allCampaigns={allCampaigns}
            />
            <EditCampaignComponent
                open={editCampaignDialog}
                companyData={editCampaignData}
                trackersData={trackers}
                onClose={async (inp) => {
                    if (inp === null) setEditCampaignDialog(false);
                    else {
                        Utils.sendProgressBar(true);
                        setEditCampaignDialog(false);
                        await getCompanyName();
                    }
                }}
                allCampaigns={allCampaigns}
            />
        </Grid>
    );
}

export default Campaigns;